# Samuraiworks JS (baseSW)
###<![CDATA[###
"use strict"
do ($ = jQuery, win = @window, doc = @document) ->
  ###UA判定し、bodyにクラスを付与suru###
  # sw ------------- chk Modern PC (ie/operaだけ) 版 IE11 add
  userAgent = window.navigator.userAgent.toLowerCase()
  appVersion = window.navigator.appVersion.toLowerCase()
  uaName = "unknown"; ios = undefined; uaNameVer = undefined
  unless userAgent.indexOf("msie") is -1
    uaName = "ie"
    unless appVersion.indexOf("msie 6.") is -1       then uaName = "ie6"
    else unless appVersion.indexOf("msie 7.") is -1  then uaName = "ie7"
    else unless appVersion.indexOf("msie 8.") is -1  then uaName = "ie8"
    else unless appVersion.indexOf("msie 9.") is -1  then uaName = "ie9"
    else unless appVersion.indexOf("msie 10.") is -1 then uaName = "ie10"
  else unless userAgent.indexOf("trident/7") is -1   then uaName = "ie11"
  else unless userAgent.indexOf("opera") is -1      then uaName = "opera"
  # ------------- sw define require (not IE)
  #console?.info "uaName:", uaName       #------- sw Log --(´･_･`)
  # do it init Assy
  $win = $(win)
  $doc = $(doc)
  ### { only these can be accessed from outside ###
  swns = {
    # 日付を返す
    theDate : ->
      today = new Date()
      day = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]
      y = today.getFullYear() + ""
      t = today.getMonth()+1
      d = today.getDate()
      w = today.getDay()
      h = today.getHours() #+9
      m = today.getMinutes()
      s = today.getSeconds()
      if(t < 10)then t ="0"+t
      if(d < 10)then d ="0"+d
      if(h < 10)then h ="0"+h
      if(m < 10)then m ="0"+m
      if(s < 10)then s ="0"+s
      #jst = "#{y}/#{t}/#{d}(#{day[w]})#{h}:#{m}:#{s}"
      return "#{y.substr(2, 2)}#{t}#{d}:#{h}#{m}:#{s}"
      # add Time (UTC to JST)
  }
  #win.__SWNS = swns
  ### only these can be accessed from outside } ###

  ###画像プリローダーAssy###
  # { sw プリロードスニペット Fixed
  preloader = (images) ->
    $(images).each -> (new Image()).src = @
  $ ->
    preloader([
    ]) # $.preLoadImages Fixed }

  ###ロールオーバーAssy###
  #------- image rollover function (fix cFs 1.7.1)
  imgRollover = (target) ->
    outImgName = "_ovoff"
    overImgName = "_ovon"
    targetArea = $("" + target + "")
    imgTagData = $("img,input", targetArea)
    reOverImg = new RegExp(outImgName + "+(.[a-z]+)$")
    reOutImg = new RegExp(overImgName + "+(.[a-z]+)$")
    imgTagData.each (i) ->
      if $(this).attr("src")?
        if $(this).attr("src").match(reOverImg)
          $("<img>").attr("src", $(this).attr("src").replace(reOverImg, overImgName + "$1"))
          $(this).bind "mouseover", ->
            $(this).attr("src", $(this).attr("src").replace(reOverImg, overImgName + "$1"))
          $(this).bind "mouseout", ->
            $(this).attr("src", $(this).attr("src").replace(reOutImg, outImgName + "$1"))




  ### plugin Type BlockLink ###
  $.fn.blocklinkAssy = () ->
    elements = @
    #settings = $.extend({target},optObj)
    elements.on("click", (e) ->
      e.preventDefault()
      window.open $(@).find("a").attr("href"), $(@).find("a").attr("target") || "_self"
    ).css cursor: "pointer"


    ### add Fixed side Menu (toc_menu.html)###
  fixedMenu = (target) ->
    nav = $(target)
    if nav.length
      # メニューのtop座標を取得する
      offsetTop = nav.offset().top
      scrollTop = undefined
      floatMenu = ->
        scrollTop = $(window).scrollTop()
        # スクロール位置がメニューのtop座標を超えたら固定にする
        if scrollTop > offsetTop
          nav.addClass 'add-fixed'
          #nav.css("top", (scrollTop + 25) + "px")
        else
          nav.removeClass 'add-fixed'
        #console.log(jQuery(window).scrollTop());
        return
      $(window).scroll floatMenu


  ### { sw jQuery WP All Pages from coffee--------------------------------- ###

  # Do it DRF
  $ ->
    ### BlockLink Assy ###
    $(".hNavi").blocklinkAssy()


    ### initRollOvers ###
    imgRollover("body")


    ###UA判定をbodyに付与（WPプラグイン使用で簡略版）###
    switch uaName
      # ieだけ(あとはWP plugin)
      when "ie6"     then $("body").addClass("ie6")
      when "ie7"     then $("body").addClass("ie7")
      when "ie8"     then $("body").addClass("ie8")
      when "ie9"     then $("body").addClass("ie9")
      when "ie10"    then $("body").addClass("ie10")
      else null

    ###UI###
    # H1, H2 wrap <span />
    $("#content h1, #content h2, #content h3").each -> $(@).wrapInner("<span class='add-span' />")
    if $("body").is(".mobile, .tablet")
      $("body.mobile #content p > img,
         body.tablet #content p > img,
         body.mobile #content p a > img,
         body.tablet #content p a > img").each ->
        width = $(@).attr("width")
        #console?.info "width:" , width      #------- sw Log --(´･_･`)
        if width > 240 then $(@).attr("width", "100%")


    ### サイドナビを固定する場合 ###
    nav = $('.list-fixed')
    offsetTop = nav.offset().top  if nav[0]?
    scrollTop = undefined
    floatMenu = ->
      scrollTop = $win.scrollTop()
      # スクロール位置がメニューのtop座標を超えたら固定にする
      if scrollTop > offsetTop
        nav.addClass 'add-fixed'
        # notice sp-slide だな。
        #nav.css("top", (scrollTop + 25) + "px")
      else
        nav.removeClass 'add-fixed'

    #console?.info "offsetTop:", offsetTop       #------- sw Log --(´･_･`)
    if nav[0]? then $win.on 'scroll', _.throttle ((e) -> floatMenu() ), 11

    ### add Fixed side Menu ###
    fixedMenu(".list-fixed")

    ### mobile hasThumbImg ###
    if $("body").is(".mobile.notHome.post-type-archive, .tablet.notHome.post-type-archive, .mobile.notHome.archive, .tablet.notHome.archive")
      $("#content article").find("div.mobileClip").each ()->
        if $(@).children().length
          $(@).addClass("on")
        else $(@).removeClass("on")



###]]>###
